import { render, staticRenderFns } from "./AverageSkills.vue?vue&type=template&id=2820da7c&"
import script from "./AverageSkills.vue?vue&type=script&lang=js&"
export * from "./AverageSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports